import React, { useContext } from "react";
import { GableSide } from "../../models/GableSide";
import { GableType } from "../../models/GableType";
import { EditorContext } from "../EditorCommon/EditorContext";
import { MaterialSelector } from "../EditorCommon/MaterialSelector";
import { DoorNumSetter } from "./DoorNumSetter";
import { DoorOverlapSetter } from "./DoorOverlapSetter";
import { UseDamperSetter } from "./UseDamperSetter";

export function AllDoorsEditor() {
    const ec = useContext(EditorContext);

    const doorProduct = ec.cabinetService.getDoorProduct();
    const supportsDamping = ec.cabinetService.supportsDoorDamping(doorProduct);
    const gableInfo = ec.cabinetService.getGableInfo();

    return (
        <ul className="nav flex-column all-doors-editor" >
            {doorProduct &&
                <li className="nav-item">
                    <div className="form-group door-num-setter">
                        <label htmlFor="door-num-selector-select">
                            {ec.translator("doorEditor NumDoors", "Antal Døre:")}
                        </label>
                        <DoorNumSetter
                            id="door-num-selector-select"
                            className="form-control"
                        />
                    </div>
                </li>
            }

            {doorProduct &&
                <li className="nav-item">
                    <div className="form-group door-overlap-setter">
                        <label htmlFor="door-overlap-setter-select">
                            {ec.translator("doorEditor NumOverlaps", "Antal overlap:")}
                        </label>
                        <DoorOverlapSetter
                            id="door-overlap-setter-select"
                            className="form-control" />
                    </div>
                </li>
            }

            {supportsDamping && (
                <li className="nav-item">
                    <div className="form-check use-damper-setter">
                        <UseDamperSetter
                            id="use-damper-setter-input"
                            className="form-check-input"
                        />
                        <label htmlFor="use-damper-setter-input"
                            className="form-check-label"
                        >
                            {ec.translator("doorEditor useDamping", "Dæmpning")}
                        </label>

                    </div>
                </li>
            )}

            {(gableInfo.left.type !== GableType.None) && (
                <li className="nav-item">
                    <div style={{ marginBottom: "16px" }}>
                        <MaterialSelector
                            header={gableInfo.left.type === GableType.Gable
                                ? ec.translator("doorEditor left gable material", "Venstre gavl")
                                : ec.translator("doorEditor left sidepanel material", "Venstre anslag")}
                            materials={ec.cabinetService.getGableMaterials(GableSide.Left)}
                            onSelect={mat => ec.cabinetService.setGableMaterialId(mat.id, GableSide.Left)}
                            currentId={ec.cabinet.leftGableMaterialId ?? undefined}
                        />
                    </div>
                </li>
            )}


            {(gableInfo.right.type !== GableType.None) && (
                <li className="nav-item">
                    <div style={{ marginBottom: "16px" }}>
                        <MaterialSelector
                            header={gableInfo.right.type === GableType.Gable
                                ? ec.translator("doorEditor right gable material", "Højre gavl")
                                : ec.translator("doorEditor right sidepanel material", "Højre anslag")}
                            materials={ec.cabinetService.getGableMaterials(GableSide.Right)}
                            onSelect={mat => ec.cabinetService.setGableMaterialId(mat.id, GableSide.Right)}
                            currentId={ec.cabinet.rightGableMaterialId ?? undefined}
                        />
                    </div>
                </li>
            )}

            <div className="alert alert-info">
                <strong>
                    {ec.translator("doorEditor allDors door help header", "Tip")}
                </strong>
                <br />
                {ec.translator("doorEditor allDors door help text", "Klik på dørene på tegningen for at ændre farver og sprosser")}
            </div>

        </ul>
    );
}
